
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.SpeedViolation = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.speedviolation.maxspeed'),
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'speed_violation_speed',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    'name': 'speed_violation_speed',
                    'maxlength': '10',
                    alt: '',
                    'value': '',
                    size: '11',
                    id: 'speed_violation_speed',
                    class: 'modelAttribute textField numberPicker mandatory',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      let value = parseFloat(jsonParam.maxSpeed),
        format = new Monet.Format.MILES_OR_KM(value),
        maxSpeed = format.formatToKmOrMilesPerHour().value;

      $('#speed_violation_speed').val(maxSpeed);
    }
  },

  retrieveParameter() {
    let value = parseFloat(
      $('#speed_violation_speed').val(),
      10
      ),
      format = new Monet.Format.MILES_OR_KM(value);

    if (Monet.Session.User.unitSystem === 'NON_METRIC') {
      format.convertMilesToKm();
    }

    return JSON.stringify({
      maxSpeed: format.value,
    });
  },

};
